import { Component, type ReactNode } from "react";
export class RouteErrorBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    return this.state.failed ? (
      <main className="workspace-page" role="alert">
        <h1>THIS PAGE COULD NOT LOAD</h1>
        <p>
          Your wallet has not sent a transaction because of this screen. If you
          were submitting one, check History before trying again.
        </p>
        <button onClick={() => window.location.reload()}>RELOAD PAGE</button>
        <a href="/history">OPEN HISTORY & RECOVERY</a>
      </main>
    ) : (
      this.props.children
    );
  }
}
